import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Sidebar } from 'primeng/primeng';

import { IDeliverableHeadings } from '../../../services/IDeliverableHeadings';

@Component({
  selector: 'app-priority-headings',
  templateUrl: './priority-headings.component.html',
  styleUrls: ['./priority-headings.component.scss']
})
export class PriorityHeadingsComponent implements OnInit {
  readonly MAX_HEADING_LENGTH = 20;

  @Output() edit = new EventEmitter<IDeliverableHeadings>();
  @Output() editError = new EventEmitter<Error>();
  @Output() cancel = new EventEmitter<void>();

  private _headingsForm: FormGroup;
  private _isActive = false;

  constructor(private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.createForm();
  }

  editHeadings(headings: IDeliverableHeadings) {
    this.isActive = true;
    this.headingsForm.patchValue({
      keyMeasureHeading : headings.keyMeasureHeading,
      objectiveHeading : headings.objectiveHeading,
      initiativeHeading : headings.initiativeHeading
    });
  }

  get isSubmitDisabled() {
    return this.headingsForm.pristine || this.headingsForm.invalid;
  }

  get headingsForm() {
    return this._headingsForm;
  }

  get objectiveHeadingField() {
    return this.headingsForm.get('objectiveHeading');
  }

  get initiativeHeadingField() {
    return this.headingsForm.get('initiativeHeading');
  }

  get keyMeasureHeadingField() {
    return this.headingsForm.get('keyMeasureHeading');
  }

  get objectiveHeadingRemainingCharacters() {
    return this.MAX_HEADING_LENGTH - this.objectiveHeadingField.value.length;
  }

  get initiativeHeadingRemainingCharacters() {
    return this.MAX_HEADING_LENGTH - this.initiativeHeadingField.value.length;
  }

  get keyMeasureHeadingRemainingCharacters() {
    return this.MAX_HEADING_LENGTH - this.keyMeasureHeadingField.value.length;
  }

  get isActive() {
    return this._isActive;
  }

  set isActive(isActive) {
    this._isActive = isActive;
  }

  onShowSidebar(sidebar: Sidebar) {
    sidebar.maskClickListener();
  }

  onHideSidebar() {
    this.resetForm();
  }

  onCancel() {
    this.cancel.emit();
  }

  onSubmit() {
    this.edit.emit(this.formToDeliverableHeadings());
  }

  private createForm() {
    const validators = [Validators.maxLength(this.MAX_HEADING_LENGTH), Validators.minLength(1), Validators.required];
    this._headingsForm = this.formBuilder.group({
      objectiveHeading: ['', validators],
      initiativeHeading: ['', validators],
      keyMeasureHeading: ['', validators]
    });
  }

  private resetForm() {
    this.headingsForm.reset({
      keyMeasureHeading: '',
      objectiveHeading: '',
      initiativeHeading: ''
    });
  }

  private formToDeliverableHeadings(): IDeliverableHeadings {
    return {
      objectiveHeading: this.objectiveHeadingField.value,
      initiativeHeading: this.initiativeHeadingField.value,
      keyMeasureHeading: this.keyMeasureHeadingField.value
    };
  }
}
